export const ACCOUNT_TEST_ID = 'account';

export const CUSTOMERS_PAGE_TEST_ID = 'customersPage';

export const HAMBURGER_MENU_TEST_ID = 'hamburgerMenu';

export const MANAGE_ORGANIZATION_TEST_ID = 'manageOrganization';

export const MANAGE_CONNECTIONS_TEST_ID = 'manageConnections';

export const MANAGE_EQUIPMENT_TEST_ID = 'manageEquipment';

export const SERVICE_OPERATOR_MAP_TEST_ID = 'serviceOperatorMap';

export const LOGOUT_TEST_ID = 'logout';

export const TEST_ID = 'siteHeader';

export const MY_ACCOUNT = 'myaccount';

export const V2_FAA_REPORTS_PATH = '/v2/faa-reports';

export const V2_FLIGHTS_AND_MAPS_PATH = '/v2/flights-and-maps';

export const V2_PRODUCT_USAGE_REPORTS_PATH = '/v2/product-usage-reports';

export const V2_WORK_ORDERS_PATH = '/v2/work-orders';
